import { render, staticRenderFns } from "./VideoProjectItem.vue?vue&type=template&id=92eafb52&scoped=true&"
import script from "./VideoProjectItem.vue?vue&type=script&lang=js&"
export * from "./VideoProjectItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoProjectItem.vue?vue&type=style&index=0&id=92eafb52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92eafb52",
  null
  
)

export default component.exports